// Module
var code = "<div class=\"address\">\n  <%= templator.render(\"visibility-bar.html\", {obj: address, inline: true}) %>\n  <a href=\"<%= m.urlRewrite(address.url, parameters) %>\"><%=m.filter.newlineComma(m.filter.h(address[\"general\"] || address[\"postal\"]))%></a>\n</div>\n";
// Exports
export default code;